'use strict';

import {fnErrorMsg, pjaxRedirect} from "../../jquery-functions-library";
import {element_exists} from "../../functions";

function getNewUrl(existingUrl, reportingPeriod) {
    //dont chain
    var element = existingUrl.split('/');
    element.splice(-1, 1);

    return element.join('/') + '/' + reportingPeriod;
}

export var fnDashMonthPicker = function () {

    var elementId = '#reporting-period';

    if (!element_exists(elementId)) return false;

    var lang = allLangFiles['month-picker'];

    var reportingDateArray = $(elementId).val().split('-');
    var reportingYear = reportingDateArray[0];
    var reportingMonth = reportingDateArray[1];
    var startYear = reportingYear;
    var minMonth = -24;
    var maxMonth = +reportingMonth + +6;

    var monthPicker = $(elementId).MonthPicker({
        MinMonth: minMonth,
        MaxMonth: 2,
        MonthFormat: 'yy-mm',
        i18n: {
            year: lang.year,
            prevYear: lang.prevYear,
            nextYear: lang.nextYear,
            next12Years: lang.next12Years,
            prev12Years: lang.prev12Years,
            nextLabel: lang.nextLabel,
            prevLabel: lang.prevLabel,
            buttonText: lang.buttonText,
            jumpYears: lang.jumpYears,
            backTo: lang.backTo,
            months: lang.months,
        },
        StartYear: startYear,
    });
    var monthPickerSelector = $('#MonthPicker_month-picker');


    $(document).off('click', '#MonthPicker_reporting-period .month-picker-month-table td a');
    $(document).on('click', '#MonthPicker_reporting-period .month-picker-month-table td a', function (e) {
        var reportingPeriod = $(elementId).val();
        var monthName = $(this).text();
        $('#reporting-month').text(monthName);

        $('.table-period-header').html('(' + monthName + ')');

        $('#reporting-period').attr('value', reportingPeriod);

        var btnBust = $('#bust_cache_btn');
        if (btnBust.length > 0) {
            btnBust.attr('data-href', getNewUrl(btnBust.attr('data-href'), reportingPeriod));
        }

        const event = new Event('monthChanged', {details: reportingPeriod});
        document.dispatchEvent(event);
        updateSelectedMonthForUser(reportingPeriod);
    });


    function updateSelectedMonthForUser(reportingPeriod) {

        $.ajax({
            type: 'POST',
            url: '/user/select_month',
            data: {selected_month: reportingPeriod},
            success: function (response) {
                /*TODO better way? What if datatable is not of scroll type*/
                $('.employee .dataTables_scrollBody > .dataTable').each(function () {
                    var existingUrl = $(this).DataTable().ajax.url();
                    if (existingUrl !== undefined) pjaxRedirect(window.location.href);
                });
            },
            error: fnErrorMsg
        })
    }
};